import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils'

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2 py-0.5 text-xs transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-slate-500/10 text-primary ',
        secondary:
          'border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80',
        outline: 'border-primary/20 text-primary',
        green:
          'h-5 border-[#08701180] bg-[#0870110D] px-2 py-0 text-[11px] font-normal leading-5 text-[#087011]',
        amber:
          'h-5 border-amber-700/25 bg-amber-50 px-2 py-0 text-[11px] font-medium leading-5 text-amber-800',
        red: 'h-5 border-[#DF001680] bg-[#DF00160D] px-2 py-0 text-[11px] font-normal leading-5 text-[#DF0016]',
        compact:
          'border-transparent bg-slate-500/10 px-1.5 py-0 text-[11px] leading-5 text-primary',
        changeNeutral:
          'rounded border-primary/10 bg-primary/5 px-1 py-0 text-[11px] font-normal leading-5 text-primary/70 tabular-nums',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export interface BadgeProps
  extends
    React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
